import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function PosTakePaymentReturn() {
  const [params] = useSearchParams();

  const data = useMemo(() => {
    const orderNumber = String(params.get('order_number') || '').trim();
    const orderTimestamp = String(params.get('order_timestamp') || '').trim();
    const okRaw = String(params.get('ok') || '').trim().toLowerCase();
    const ok = okRaw === 'true' || okRaw === '1' || okRaw === 'yes';
    const transactionId = String(params.get('transaction_id') || '').trim();
    const clientTransactionId = String(params.get('client_transaction_id') || '').trim();
    const errorCode = String(params.get('error_code') || '').trim();

    const qp = new URLSearchParams();
    if (orderNumber) qp.set('order_number', orderNumber);
    if (orderTimestamp) qp.set('order_timestamp', orderTimestamp);
    qp.set('ok', ok ? 'true' : 'false');
    if (transactionId) qp.set('transaction_id', transactionId);
    if (clientTransactionId) qp.set('client_transaction_id', clientTransactionId);
    if (errorCode) qp.set('error_code', errorCode);

    const deepLink = `com.ezsellproducts.admin://pos/take-payment/return?${qp.toString()}`;

    return {
      orderNumber,
      orderTimestamp,
      ok,
      transactionId,
      clientTransactionId,
      errorCode,
      deepLink,
    };
  }, [params]);

  const title = data.ok ? 'Payment complete' : 'Payment result';
  const subtitle = data.orderNumber ? `Order: ${data.orderNumber}` : '';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18 }}>
      <div style={{ width: '100%', maxWidth: 520 }}>
        <div
          style={{
            borderRadius: 16,
            border: '1px solid rgba(15, 23, 42, 0.10)',
            boxShadow: '0 18px 42px rgba(2, 6, 23, 0.10)',
            padding: 18,
            background: '#fff',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 18, fontWeight: 900, color: '#0f172a' }}>{title}</div>
              {subtitle ? <div style={{ marginTop: 6, color: 'rgba(15, 23, 42, 0.75)' }}>{subtitle}</div> : null}
              {data.errorCode ? (
                <div style={{ marginTop: 10, color: '#b91c1c', fontWeight: 700 }}>Error: {data.errorCode}</div>
              ) : null}
            </div>
            <div
              style={{
                padding: '6px 10px',
                borderRadius: 999,
                fontWeight: 900,
                fontSize: 12,
                background: data.ok ? 'rgba(34, 197, 94, 0.12)' : 'rgba(148, 163, 184, 0.25)',
                color: data.ok ? '#15803d' : '#334155',
                whiteSpace: 'nowrap',
              }}
            >
              {data.ok ? 'PAID' : 'UNKNOWN'}
            </div>
          </div>

          <div style={{ marginTop: 14, color: 'rgba(15, 23, 42, 0.75)', lineHeight: 1.4 }}>
            Tap below to return to the EzSell Admin app.
          </div>

          <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <a
              href={data.deepLink}
              style={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 8,
                textDecoration: 'none',
                borderRadius: 12,
                padding: '12px 14px',
                background: '#4c1d95',
                color: '#fff',
                fontWeight: 900,
              }}
            >
              Open EzSell Admin
            </a>

            <Link
              to="/admin/channels/pos/queue"
              style={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                textDecoration: 'none',
                borderRadius: 12,
                padding: '12px 14px',
                border: '1px solid rgba(15, 23, 42, 0.12)',
                color: '#0f172a',
                fontWeight: 800,
                background: '#fff',
              }}
            >
              Continue on web
            </Link>
          </div>

          <div style={{ marginTop: 14, fontSize: 12, color: 'rgba(15, 23, 42, 0.55)' }}>
            If you still see an “Open” prompt, that is iOS security behavior. Universal Links reduce it, but can’t eliminate it in every
            app/browser context.
          </div>
        </div>
      </div>
    </div>
  );
}
